<template>
  <div class="container course-wishlist">
    <div class="pb-3 row justify-content-end">
      <h6 class="col-md-12 main-title">{{$t('wishlist.labels.MyWishlist')}}</h6><b-form-input placeholder ="search items from wishList" v-if="$store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length>0" type ="text" v-model="keyWord"></b-form-input>
    </div>
    

    <!-- if items added in wishList -->
    <div v-if="$store.getters.getWishListDataMatchingKeyWord(keyWord) !== undefined && $store.getters.getWishListDataMatchingKeyWord(keyWord) !== null && $store.getters.getWishListDataMatchingKeyWord(keyWord).length>0">
      <div class="row">
        <div class="col-sm-6 col-md-5 col-lg-4 col-xl-3" v-for="(wishList,index) in $store.getters.getWishListDataMatchingKeyWord(keyWord)" :key="index">
          <div class="card-design">
            <div class="card-design__img">
              <img :src="makePath(wishList.Thumbnail, wishList.type)" alt="">
            </div>
            <div class="card-design__data">
              <h3 v-b-tooltip.hover :title="wishList.itemName" class="card-design__data-heading text-truncate" style="text-decoration:none">{{wishList.itemName}}</h3>
              <h3 class="card-design__data-cost"></h3>
              <div class="row mt-3">
                <div class="col">
                  <button v-if="!$store.getters.itemPresentInCartStatus(wishList.itemId)" @click="addToCart(wishList.itemId)" class="btn btn-green-o">{{$t('wishlist.labels.MoveToCart')}}</button>
                  <button v-else class="btn btn-green-o">{{$t('common.labels.ADDED')}}</button>
                </div>
                <div v-if="!$store.getters.itemPresentInCartStatus(wishList.itemId)" class="col-auto act-holder">
                  <button @click="removeDataFromWishList(profileId,wishList.itemId)" :title="$t('wishlist.labels.RemoveFromWishlistMsg')" class="btn btn-danger trash">
                    <span class="mdi mdi-delete"></span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if ="keyWord.length == 0 && $store.getters.getWishListDataNotPresentInCart($store.getters.getCartData) != undefined && $store.getters.getWishListDataNotPresentInCart($store.getters.getCartData) != null && $store.getters.getWishListDataNotPresentInCart($store.getters.getCartData).length > 0" class="text-center">
        <button @click="moveAllToCart($store.getters.getWishListStoreData)" class="btn btn-large btn-blue mt-3"> {{$t('wishlist.labels.MoveAllToCart')}}</button>
        <button @click="clearUserWishList()" class="btn btn-large btn-danger mt-3"> Clear WishList</button>
      </div>
    </div>
    <!-- if no items in wishList -->
    <div v-else>
      <div class="row">
        <div class="col noticemsg">
          <span>{{$t('wishlist.labels.AddCoursesInWishlist')}}</span>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { CDP_CDN_THUMBNAIL_URL } from '@/components/common/constants.js'
import axios from 'axios'
export default {
  name: 'courseWishlist',
  data () {
    return {
      profileId: this.$store.getters.getProfileDetails.profileId,
      keyWord: ''
    }
  },
  methods: {
    clearUserWishList () {
      this.$swal({
        title: 'Do yo want to remove all the items from wishList ?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          return new Promise((resolve, reject) => {
            axios
            .post('r/clearUserWishList', {'profileId': this.$store.getters.getProfileDetails.profileId})
            .then(res => {
              if (res.status === 200) {
                this.$store.dispatch('resetWishListInStore').then(res => {
                  this.$toasted.success('wishList emptied')
                  resolve()
                }, err => {
                  console.log('ERROR_IN_RESETING_STORE : ', err)
                  reject()
                })
              } else {
                reject()
              }
            })
            .catch(err => {
              console.log('ERROR_IN_CLEARING_WISHLIST : ', err)
              this.$toasted.success('Something went wrong')
              reject()
            })
          })
        }
      })
    },
    makePath (path, type) {
      if (path.length !== 0) {
        return CDP_CDN_THUMBNAIL_URL + '/' + path
        // return 'http://10.2.10.230:3035/cdpcdn/thumnail/' + path
      } else {
        if (type === 'CO') {
          return '../../../static/assets/images/defaultCO.jpg'
        } else if (type === 'LO') {
          return '../../../static/assets/images/defaultLO.jpg'
        }
      }
    },
    removeDataFromWishList (profileId, itemId) {
      this.$swal({
        title: this.$t('wishlist.alerts.RemoveItemConfirm'),
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          this.$store.dispatch('removeWishListFromDb', { profileId, itemId }).then(
            response => {
              this.$toasted.success(this.$t('wishlist.alerts.RemoveItem'))
            },
            error => {
              console.log('error in removing item from db', error)
            }
          )
        }
      })
    },
    addToCart (id) {
      this.$store.dispatch('addCartData', { itemId: id, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(
        response => {
          this.$toasted.success(this.$t('common.alerts.CART_ADDED_SUCCESS'))
        },
        error => {
          this.$toasted.error(this.$t('common.errors.CartItemAddError'))
          console.log('error in adding item to cart', error)
        }
      )
      // this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: id })
    },
    moveAllToCart (obj) {
      for (let i = 0; i < obj.length; i++) {
        this.$store.dispatch('addCartData', { itemId: obj[i].itemId, profileId: this.$store.getters.getProfileDetails.profileId, cartId: this.$store.getters.getCartData.cartId }).then(
          response => {
            if (i === obj.length - 1) {
              this.$toasted.success(this.$t('common.alerts.ALL_CART_ADDED_SUCCESS'))
            }
          },
          error => {
            this.$toasted.error(this.$t('common.errors.CartItemAddError'))
            console.log('error in adding item to cart', error)
          }
        )
        // this.$store.dispatch('removeWishListFromDb', { profileId: this.$store.getters.getProfileDetails.profileId, itemId: obj[i].itemId })
      }
    },
    cartAdd (itemId) {
      if (this.$store.getters.getCartData.items !== undefined && this.$store.getters.getCartData.items !== null) {
        for (var j = 0; j < this.$store.getters.getCartData.items.length; j++) {
          if (this.$store.getters.getCartData.items[j].itemId === itemId) {
            return true
          }
        }
      }
      return false
    }
  },
  created () {
    // alert('in created')
    this.$store.dispatch('getWishListFromDb', this.profileId)
    // alert('after')
    // alert(JSON.stringify(this.wishListData))
  }
}
</script>

<style lang="scss">
@import '../../../static/assets/styles/scss/variables.scss';
.course-wishlist {
  padding-top: 50px;
  padding-bottom: 50px;
  .card {
    border-radius: 3px;
    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.18);
    border: none;
    background-color: #fff;
    transition: box-shadow 0.25s;
    margin-bottom: 35px;
    padding: 25px;
    .row {
      .video-col {
        .video-css {
          width: 100%;
          height: 100%;
          border-radius: 3px;
          object-fit: cover;
        }
        .overlay {
          width: 100%;
          height: 100%;
          top: 0px;
          border-radius: 3px;
          position: absolute;
          z-index: 2;
          background: linear-gradient(to right, rgba(92, 184, 234, 0.9) 0%, rgba(110, 99, 197, 0.9) 100%);
        }
      }
    }
    .description {
      h5 {
        color: #333;
        font-size: 15px;
        line-height: 25px;
        font-family: $opensans;
        font-weight: 600;
      }
      p {
        color: #555;
        font-size: 12px;
      }
      .details-css {
        padding-right: 10px;
        font-size: 12px;
        margin-bottom: 20px;
        display: inline-block;
        span {
          color: #555;
          font-size: 12px;
        }
        strong {
          color: #333;
          font-size: 12px;
          padding-left: 8px;
        }
      }
      .rating-star {
        font-size: 12px;
        display: inline-block;
        color: #555;
        .stars {
          padding-left: 10px;
        }
        padding-right: 10px;
      }
    }
    .play-icon {
      display: none;
      top: 48%;
      left: 41%;
      position: absolute;
      z-index: 2;
      .fa {
        font-size: 72px;
        line-height: 0px;
        color: rgba(255, 255, 255, 0.7);
      }
    }
    &:hover {
      cursor: pointer;
      transition: box-shadow 0.45s;
      box-shadow: 0px 10px 45px rgba(0, 0, 0, 0.25);
      .play-icon {
        .fa {
          color: rgba(255, 255, 255, 0.9);
        }
      }
    }
  }
  // .action-btn{
  //     position: absolute; bottom:0px;
  // }
   @media (max-width: 576px) {
  .main-title {text-align:center;}
  }
  @media (min-width: 577px) {
    .main-title {text-align:left;}
  }
}
</style>


// WEBPACK FOOTER //
// src/components/wishList/courseWishList.vue?266e59c0